// extracted by mini-css-extract-plugin
export default {"container":"MedicalLayout_container__ZWmD6","header":"MedicalLayout_header__QFquL","logo":"MedicalLayout_logo__eEg9B"};